(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SmsLimitDialogController', SmsLimitDialogController);

    SmsLimitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SmsLimit'];

    function SmsLimitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SmsLimit) {
        var vm = this;

        vm.smsLimit = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.smsLimit.id !== null) {
                SmsLimit.update(vm.smsLimit, onSaveSuccess, onSaveError);
            } else {
                SmsLimit.save(vm.smsLimit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:smsLimitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
